import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import { IinsuredList, Iuser } from "../types/step-tree-interface";


export const fetchStepTree = createAsyncThunk(
    'contract/fetchStepTree',
    async ({
        projectId,
        sellerId,
        regionId,
        productId,
        clientId,
        policyholderIsSame,
        beginDate,
        user,
        insuredList,
        programId
    }: {
        projectId: string;
        sellerId: string;
        regionId: string;
        productId: string;
        clientId: string;
        policyholderIsSame: boolean;
        beginDate: string;
        user: Iuser;
        insuredList: IinsuredList[];
        programId: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            projectId: projectId,
            userId: "",
            sellerId: sellerId,
            regionId: regionId,
            productId: productId,
            clientId: clientId,
            policyholderIsSame: policyholderIsSame,
            beginDate: beginDate,
            user: user,
            insuredList: insuredList,
            programId: programId
        };
        try {
            const response = await getRequest(requestBody, 'max-bot', 'getSaveProject', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    uid: data.Data.uid, price: data.Data.price, paylink: data.Data.paylink, polis: data.Data.polis
                };
            } else {
                return data.Errors;
            }
        } catch (error: any) {
            return error.message;
        }
    }
);
